window.FontAwesomeConfig = {
    searchPseudoElements: true
};

$(document).ready(function(){

    $(document).foundation();


    // if( window.innerWidth >=1024 ) {
    //     var startingLogo = $( 'header .logo img:not(.hide)');
    //
    //     $( '[data-hover-logo]').hover(function () {
    //         $( 'header .logo img').addClass( 'hide' );
    //         $( 'header .logo .' + $( this ).attr('data-hover-logo') ).removeClass('hide');
    //     },function () {
    //         $( 'header .logo img').addClass( 'hide' );
    //         startingLogo.removeClass('hide');
    //     });
    //
    // }


    if ($(".social-buttons").length) {
        $( '.social-buttons a' ).click(function( e ){
            e.preventDefault();
            m40_socialShare( this.href, 640, 480 );
        });
        window.m40_socialShare = function(url, winWidth, winHeight) {
            var winTop = (window.innerHeight / 2) - (winHeight / 2);
            var winLeft = (window.innerWidth / 2) - (winWidth / 2);
            window.open(url, 'm40_sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            return false;
        };
    }

    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }

// Search Container - Trigger is in secondary-navigation.twig
    $(".search-trigger").on('click', function(e) {

        var isActive = !$(".search-container").hasClass("active");

        e.preventDefault();

        $(".search-container").toggleClass("active");
        $(".search-active-overlay").toggleClass("fade-content");
        $("html").toggleClass("no-scroll");

        if( isActive ) $( '.search-input').get(0).focus();
        else $( '.search-input').get(0).blur();
    });

    $(".search-close").on('click', function(e) {
        e.preventDefault();
        $(".search-container").removeClass("active");
        $(".search-active-overlay").removeClass("fade-content");
        $("html").removeClass("no-scroll");
    });

    $( '.news-item' ).hover(function(){
        $( this ).toggleClass( 'is-active' );
    });

    $( '.news-item' ).click(function(){
        $(this).find('a')[0].click();
    });

    // esc key action
    $(document).keyup(function(e) {
        if (e.keyCode == 27) { // Esc
            $(".search-container").removeClass("active");
            $(".search-active-overlay").removeClass("fade-content");
            $("html").removeClass("no-scroll");
        }
    });


    window.addEventListener("load", function()
    {
        if( window.cookieconsent ) 
        {
            window.cookieconsent.initialise({
                
                palette: {
                    popup: {
                        background: "#4b5771",
                        text: "#fff",
                        link: '#fff'
                    },
                    button: {
                        background: "#ffffff",
                        text: '#2256aa'
                    }
                },
                theme: "edgeless",
                content: {
                    message: "By using this website you are agreeing to our cookie policy.",
                    href: "/site-pages/cookies/",
                    dismiss: 'I Accept',
                },
                dismissOnScroll: false
            });
        }
    });

});
